import { Calendar, Paperclip, Clock, User, CalendarCheck } from 'lucide-react';

const HeaderIjin = ({ item }) => {
  // Ambil data jenis ijin dari localStorage
  const getJenisIjinInfo = () => {
    try {
      const jenisIjinList = JSON.parse(localStorage.getItem('jenis_izin_list') || '[]');
      const foundIjin = jenisIjinList.find(ijin => ijin.id == item.absen_id);

      if (foundIjin) {
        return `${foundIjin.nama}`;
      }
    } catch (error) {
      console.error('Error parsing jenis_ijin_list:', error);
    }

    // Fallback judul jika jenis izin tidak ditemukan.
    return 'Izin';
  };

  const getKeteranganIjinInfo = () => {
    try {
      const jenisIjinList = JSON.parse(localStorage.getItem('jenis_izin_list') || '[]');
      const foundIjin = jenisIjinList.find(ijin => ijin.id == item.absen_id);

      if (foundIjin) {
        let text = foundIjin.keterangan || '';
        if (text.trim().toLowerCase() === 'mendadak') {
          text = 'Mendesak';
        }
        if (text.length > 27) {
          text = text.substring(0, 27) + '...';
        }
        return text;
      }
    } catch (error) {
      console.error('Error parsing jenis_ijin_list:', error);
    }

    // Jika jenis/keterangan absen tidak tersedia, UI akan menampilkan "Mendesak".
    return '';
  };

  const keteranganIjinText = getKeteranganIjinInfo();

  const jenisIjinText = getJenisIjinInfo();

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return '-';
    try {
      return new Date(dateStr).toLocaleString('id-ID', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      }).replace('.', ':');
    } catch (e) { return dateStr; }
  };

  const leavePeriodText = item.log ? item.log.split(',').map(d => d.trim()).join(' - ') : item.tanggal;

  return (
    <>
      <div style={{ marginBottom: 10, display: 'flex', flexDirection: 'row', gap: 12 }}>
        <Calendar size={28} color="#6366f1" style={{ marginTop: 6, flexShrink: 0 }} />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <div>
            <h3
              style={{
                margin: 0,
                fontSize: 16,
                fontWeight: 600,
              }}
            >
              Pengajuan {jenisIjinText}
            </h3>
            <span style={{ fontSize: 13, display: 'block', marginTop: 2 }}>
              {keteranganIjinText || 'Mendesak'}
            </span>
          </div>
        </div>
      </div>
      <div style={{
        marginTop: 12,
        padding: '12px',
        backgroundColor: '#f8fafc',
        borderRadius: 12,
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        border: '1px solid #f1f5f9'
      }}>
        {/* Info Dibuat */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#64748b' }}>
          <Clock size={14} color="#94a3b8" />
          <span>Dibuat pada: <span style={{ color: '#475569', fontWeight: 500 }}>{formatDisplayDate(item.created_at)}</span></span>
        </div>

        {/* Info Periode Izin */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#64748b' }}>
          <CalendarCheck size={14} color="#6366f1" />
          <span>Izin untuk: <span style={{ color: '#475569', fontWeight: 600 }}>{leavePeriodText}</span> 
            <span style={{ marginLeft: 6, color: '#722ed1', fontWeight: 500 }}>({item.jumlah} hari)</span>
          </span>
        </div>

        {/* Info Pengganti */}
        {item.nama_pengganti && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12, color: '#64748b' }}>
            <User size={14} color="#94a3b8" />
            <span>Pengganti: <span style={{ color: '#475569', fontWeight: 500 }}>{item.nama_pengganti}</span></span>
          </div>
        )}

        {/* Keterangan / Note */}
        <div
          style={{
            fontSize: 12,
            color: '#64748b',
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            marginTop: 2,
            paddingTop: 8,
            borderTop: '1px solid #f1f5f9'
          }}
        >
          <Paperclip size={14} color="#94a3b8" />
          <span style={{ fontStyle: 'italic' }}>{item.nama || '-'}</span>
        </div>
      </div>
    </>
  );
};

export default HeaderIjin;
